import { FunctionComponent } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type Props = {};

const AuthButtons: FunctionComponent<Props> = ({}) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="nav__buttons">
      <button
        className="nav__login"
        onClick={() =>
          navigate("/login", { state: { from: location.pathname } })
        }
      >
        Iniciar sesión
      </button>
      <div onClick={() => navigate("/sign-up")}>
        <p className="nav__signup">Registrarse</p>
      </div>
    </div>
  );
};

export default AuthButtons;
